var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioAudio13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M44.713,48.656h-6.529c-0.412,0-0.744-0.333-0.744-0.744V12.748c0-0.411,0.332-0.744,0.744-0.744h6.529 c0.41,0,0.744,0.333,0.744,0.744v35.164C45.457,48.323,45.123,48.656,44.713,48.656z M38.927,47.168h5.042V13.492h-5.042V47.168z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M15.512,48.656c-0.19,0-0.381-0.072-0.526-0.218c-0.291-0.29-0.291-0.762,0-1.053l17.056-17.057 L14.985,13.274c-0.291-0.291-0.291-0.762,0-1.053c0.29-0.291,0.761-0.291,1.052,0L33.62,29.803c0.14,0.141,0.218,0.33,0.218,0.526 c0,0.197-0.078,0.387-0.218,0.525L16.037,48.438C15.892,48.584,15.701,48.656,15.512,48.656z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M30,60.001C13.458,60.001,0,46.543,0,30C0,13.458,13.458-0.001,30-0.001c16.543,0,30,13.459,30,30.001 C60,46.543,46.543,60.001,30,60.001z M30,2.976C15.1,2.976,2.977,15.099,2.977,30C2.977,44.9,15.1,57.023,30,57.023 C44.901,57.023,57.023,44.9,57.023,30C57.023,15.099,44.901,2.976,30,2.976z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioAudio13);
export default __webpack_public_path__ + "static/media/Audio_Audio-13.85785056807b541bf75e4dd478ef615e.svg";
export { ForwardRef as ReactComponent };